import { useUser } from '../../auth/useUser';

export default function PostSignupModal() {
    const { showPostSignupModal, dismissPostSignupModal } = useUser();

    if (!showPostSignupModal) return null;

    return (
        <div className="fixed inset-0 bg-black/65 flex items-center justify-center z-50 p-4 animate-in fade-in duration-200">
            <div className="glass-strong max-w-md w-full p-6 relative animate-in zoom-in-95 duration-200">
                {/* Close button */}
                <button
                    onClick={dismissPostSignupModal}
                    className="absolute top-4 right-4 btn-ghost px-2 py-2 text-slate-400 hover:text-slate-600 dark:text-slate-300 dark:hover:text-slate-100"
                    aria-label="Close"
                >
                    <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>

                {/* Icon */}
                <div className="w-16 h-16 bg-gradient-to-br from-emerald-400 to-teal-500 rounded-2xl flex items-center justify-center mx-auto mb-4 shadow-[0_16px_30px_-20px_rgba(52,211,153,0.70)] border border-slate-200 dark:border-white/10">
                    <svg className="w-8 h-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                </div>

                {/* Content */}
                <h2 className="text-xl font-bold text-slate-900 dark:text-slate-50 text-center mb-2">
                    Welcome to AuraIcon!
                </h2>
                <p className="text-slate-600 dark:text-slate-300 text-center mb-6">
                    Your account has been created. Please check your inbox for a verification email to unlock downloads.
                </p>

                {/* Benefits reminder */}
                <div className="bg-violet-500/10 border border-violet-400/20 rounded-2xl p-4 mb-6">
                    <p className="text-sm text-violet-900 dark:text-violet-100 font-medium mb-2">
                        📧 Verify your email to:
                    </p>
                    <ul className="space-y-1 text-sm text-violet-700 dark:text-violet-200/80">
                        <li>• Download your icons in all sizes</li>
                        <li>• Access your icon history</li>
                        <li>• Unlock premium features</li>
                    </ul>
                </div>

                {/* Buttons */}
                <div className="space-y-3">
                    <button
                        onClick={dismissPostSignupModal}
                        className="w-full btn-primary py-3"
                    >
                        Got it!
                    </button>
                </div>
            </div>
        </div>
    );
}
